import * as React from "react";

import Context from "./context";

function useTable() {
  return React.useContext(Context);
}

export default useTable;
